
import React from 'react'
import { Refresh } from '@material-ui/icons/'

const RefreshPageButton = () => {

    const handleRefreshPage = () => {
        window.location.reload(false);
    }

    return (
        <>
            <button title='Refresh' data-testid="test-btn-refresh-page" className="p-2 btn btn-warning btn-sm"
                onClick={() => handleRefreshPage()}>
                <Refresh className='px-1' fontSize="small"></Refresh>
                <span className="px-2">Refresh</span>
            </button>
        </>
    )
}

export default RefreshPageButton
